/**
 * Generated by orval. Do not edit manually.
 */

export type BrevoRevenueReportStatus =
  (typeof BrevoRevenueReportStatus)[keyof typeof BrevoRevenueReportStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrevoRevenueReportStatus = {
  pending: 'pending',
  running: 'running',
  complete: 'complete',
  failed: 'failed',
} as const
